(() => {
  const mobileTouchQuery = window.matchMedia(
    '(hover: none) and (pointer: coarse)'
  );

  function isPointInside(element, event) {
    const rect = element.getBoundingClientRect();

    return (
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom
    );
  }

  function closeOtherCards(currentCard) {
    document
      .querySelectorAll(
        '.product-card-wrapper.st-secondary-active'
      )
      .forEach((card) => {
        if (card !== currentCard) {
          card.classList.remove('st-secondary-active');
        }
      });
  }

  function handleProductCardTap(event) {
    if (!mobileTouchQuery.matches) return;

    const card = event.target.closest('.product-card-wrapper');
    if (!card) return;

    const media = card.querySelector(
      '.card__media .media--hover-effect'
    );

    if (!media) return;

    const images = media.querySelectorAll(':scope > img');

    // Do nothing when the product has no second image.
    if (images.length < 2) return;

    // Only activate when the customer taps inside the image area.
    if (!isPointInside(media, event)) return;

    // The second tap should open the product normally.
    if (card.classList.contains('st-secondary-active')) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    closeOtherCards(card);
    card.classList.add('st-secondary-active');
  }

  function closeCardsWhenTappingOutside(event) {
    if (!mobileTouchQuery.matches) return;

    const tappedCard = event.target.closest(
      '.product-card-wrapper'
    );

    if (!tappedCard) {
      document
        .querySelectorAll(
          '.product-card-wrapper.st-secondary-active'
        )
        .forEach((card) => {
          card.classList.remove('st-secondary-active');
        });
    }
  }

  document.addEventListener('click', handleProductCardTap, true);
  document.addEventListener(
    'click',
    closeCardsWhenTappingOutside,
    false
  );

  document.addEventListener('shopify:section:load', () => {
    document
      .querySelectorAll(
        '.product-card-wrapper.st-secondary-active'
      )
      .forEach((card) => {
        card.classList.remove('st-secondary-active');
      });
  });
})();